module.exports = __webpack_public_path__ + "/9ac04316413e58447ad279e48449d710.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/signature_icon.svg
 ** module id = 839
 ** module chunks = 0
 **/